<div class="tooltip-container" (mouseleave)="this.mouseLeave()">
  <ng-template #simpleText>
    {{ text }}
  </ng-template>
  <ng-container *ngTemplateOutlet="contentTemplate || simpleText">
  </ng-container>
</div>
